import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_SURCHARGE_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const appraisalSurchargeSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APPRAISAL_SURCHARGE_SCHEMA_ACTION_TYPE.GET_APPRAISAL_SURCHARGE_SCHEMA:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default appraisalSurchargeSchemaReducer;
